import type { CreateCatalogItemRequest } from '@kreart/shared';
import { errorKeyFor } from '@/features/catalog/errorMessages';
import { useCreateCatalogItem } from '@/features/catalog/hooks';
import { toastError, toastSuccess } from '@/lib/toast';

export function useSaveCatalogBlueprint() {
  const createCatalogItem = useCreateCatalogItem();

  const saveCatalogBlueprint = async (body: CreateCatalogItemRequest): Promise<boolean> => {
    try {
      await createCatalogItem.mutateAsync(body);
      toastSuccess('projectItems.actions.savedToCatalog');
      return true;
    } catch (err) {
      toastError(err, errorKeyFor);
      return false;
    }
  };

  return {
    isPending: createCatalogItem.isPending,
    saveCatalogBlueprint,
  };
}
